export default {
    setLoading(state, payload){
        state.loading.show    = payload.show,
        state.loading.message = payload.message
    },

    setAlert(state, payload){
        state.alert.show    = payload.show
        state.alert.type    = payload.type
        state.alert.message = payload.message
    }
}
